import * as yup from 'yup';

import type { IValidationField } from '../types';

export default function boolean({ label = '' }: IValidationField) {
  return yup.boolean().label(label);
}
